import https from "../../configs/axios.config";
import { API_ROUTES } from "../../constants/API_ROUTES";

export const orderService = {
  get_list_order: (token, params = {}) => {
    const uri = API_ROUTES.ORDER.GET_LIST_ORDER;
    return https.get(uri, {
      params,
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
  },

  get_detail_order: (token, orderId) => {
    const uri = API_ROUTES.ORDER.GET_DETAIL_ORDER.replace(":orderId", orderId);
    return https.get(uri, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
  },
  update: (token, orderId, data) => {
    const uri = API_ROUTES.ORDER.UPDATE.replace(":orderId", orderId);
    return https.put(uri, data, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
  },
};
